export default __webpack_public_path__ + "static/media/expl_gradcam_10_DE.f8740f6e.png";